import { Component, OnInit } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { UpdateJobProcessStep } from './actions/process.actions';
import { AppState } from '../../app.service';
import { ProcessStepModel } from './process.model';
import { Subject } from 'rxjs';
import { selectProcess } from './selectors/process.selectors';

@Component({
  selector: 'mj-edit-job-tpl-job-process',
  templateUrl: './edit-job-tpl-job-process.component.html',
  styleUrls: ['./edit-job-tpl-job-process.component.scss'],
})
export class EditJobTplJobProcessComponent implements OnInit {
  blurActive: boolean;
  steps: ProcessStepModel[] = [];

  stepOpenedUuid$ = new Subject<string>();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store.pipe(select(selectProcess)).subscribe(process => {
      if (process) {
        if (this.steps.length === 0) {
          return this.refreshSteps(process.steps);
        }

        // check if positions are changed
        const shouldUpdate =
          this.steps[0].position &&
          process.steps.some(step => {
            return (
              this.steps.find(elem => elem.id === step.id).position !==
              step.position
            );
          });

        if (shouldUpdate) {
          return this.refreshSteps(process.steps);
        }
      }
    });
  }

  onProcessChange(e) {
    this.store.dispatch(
      new UpdateJobProcessStep({ id: e.id, changes: e.changes })
    );
  }

  refreshSteps(steps) {
    this.steps = steps;
    this.steps = this.steps.sort((a, b) => {
      return a.position > b.position ? 1 : -1;
    });
  }

  onBlurChanged(isActive: boolean) {
    this.blurActive = isActive;
  }
}
